import http from '../../../../api/axios';
import { apiUrl } from '../../../../api/apiUrl';
import { Values } from '../../../../forms/Team/TeamForm.types';
import { handleApiErrors } from '../../../../api/apiErrorHandler';
import { TeamForm } from '../../../../forms/Team/TeamForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Team } from '../../../../types/Team';
import { toast } from 'react-toastify';
import { TeamMemberAssign } from '../../../../forms/TeamMemberAssign/TeamMemberAssign';
import { Loader } from '../../../../components/loader/Loader';
import { useTranslation } from '../../../../context/translationContext';
import { paths } from '../../../RouterContainer';
import { useBreadcrumbs } from '../../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../../context/loadingContext';

/**
 * Page component represents Teams edit page
 */
export const UserTeamsUpdatePage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [team, setTeam] = useState<Team | null>(null);
  const { startLoading, stopLoading } = useLoading();
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_TEAMS}`,
        name: 'navigation.my-teams',
      },
      {
        path: `${paths.MY_TEAMS}/edit/${id}`,
        name: 'navigation.my-teams-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () => {
    return navigate(`/${paths.MY_TEAMS}`);
  };

  /**
   * Loads team
   */
  const fetchTeam = async () => {
    if (!id) return;
    const response = await http.apiGet({ url: `${apiUrl.TEAM_GET}?id=${Number(id)}` });
    setTeam(response?.data);
  };

  useEffect(() => {
    fetchTeam();
  }, []);

  /**
   * Handles edit action. Uses team edit API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({ url: apiUrl.TEAM_UPDATE, data: values });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (!team) return <Loader />;
  return (
    <>
      <h1 className="text-3xl font-bold">{t('page.team.headline-edit')}</h1>
      <div className="flex">
        <div className="w-1/2 pr-10">
          <TeamForm onSubmit={handleSubmit} initialValues={team as Values} onBack={handleOnBack} />
        </div>
        <div className="w-1/2">
          <p className="text-2xl font-bold mb-5">{t('page.team-member.headline')}</p>
          <TeamMemberAssign teamId={Number(id)} isReadOnly={true} />
        </div>
      </div>
    </>
  );
};
